module.exports = __webpack_public_path__ + "img/network_locked.f46d38de.svg";